import { ClientData } from "../models/api-models";

export const routes = {
    userAuthenticate: () => 'v1/users/authenticate',
    userVerifyMfa: () => 'v1/users/verify-mfa',
    userSignUp: () => 'v1/users/signUp',
    clientAuthenticate: () => 'v1/clients/authenticate',
    userLogout: () => 'v1/users/logout',
    clientLogout: () => 'v1/clients/logout',
    usersMe: () => 'v1/users/me',
    usersMePreferences: () => 'v1/users/me/preferences',
    users: () => 'v1/users',
    user: (id: string) => `v1/users/${id}`,
    userProfilePic: (id: string) => `v1/users/${id}/profile-pic`,
    userChangeLog: (id: string) => `v1/users/${id}/changeLog`,
    usersMeConfirmEmail: () => 'v1/users/me/confirmationEmail',
    usersConfirmEmail: (id: string) => `v1/users/${id}/confirmationEmail`,
    usersResetPassword: () => `v1/users/resetPassword`,
    usersMeAuthenticatorSetup: () => 'v1/users/me/mfa/authenticator-setup',
    usersMeAuthenticatorConfirm: () => 'v1/users/me/mfa/authenticator-confirm',
    usersMeAuthenticatorDisable: () => 'v1/users/me/mfa/authenticator',
    clients: () => 'v1/clients',
    client: (id: string) => `v1/clients/${id}`,
    clientTags: (id: string) => `v1/clients/${id}/tags`,
    clientInternalNotes: (id: string) => `v1/clients/${id}/internal-notes`,
    clientsReduced: () => 'v1/clients/reduced',
    clientsSearch: () => `v1/clients/search`,
    clientsDuplicates: () => `v1/clients/duplicates`,
    clientsEntityCounts: () => `v1/clients/entity-counts`,
    clientAppointments: (id: string) => `v1/clients/${id}/appointments`,
    clientAppointmentsChanges: (id: string) => `v1/clients/${id}/appointments-changes`,
    clientChangeLog: (id: string) => `v1/clients/${id}/changeLog`,
    clientReports: (id: string) => `v1/clients/${id}/reports`,
    clientReport: (id: string, reportId: string) => `v1/clients/${id}/reports/${reportId}`,
    clientReportSendEmail: (id: string, reportId: string) => `v1/clients/${id}/reports/${reportId}/send-email`,
    clientPacks: (id: string) => `v1/clients/${id}/packs`,
    clientPack: (clientId: string, packId: string) => `v1/clients/${clientId}/packs/${packId}`,
    clientOrders: (clientId: string) => `v1/clients/${clientId}/orders`,
    clientOrder: (clientId: string, orderId: string) => `v1/clients/${clientId}/orders/${orderId}`,
    clientOrderChangeLog: (clientId: string, orderId: string) => `v1/clients/${clientId}/orders/${orderId}/changeLog`,
    orderById: (orderId: string) => `v1/orders/${orderId}`,
    clientFiles: (id: string) => `v1/clients/${id}/files`,
    clientFile: (id: string, fileId: string) => `v1/clients/${id}/files/${fileId}`,
    clientFileSendEmail: (id: string, fileId: string) => `v1/clients/${id}/files/${fileId}/send-email`,
    clientMintuPause: (id: string) => `v1/clients/${id}/mintu-pause`,
    clientCommunications: (id: string) => `v1/clients/${id}/communication`,
    sendClientCommunication: (id: string) => `v1/clients/${id}/communication`,
    updateClientCommunicationObservations: (clientId: string, communicationId: string) => `v1/clients/${clientId}/communication/${communicationId}/observations`,
    unreadCommunications: () => 'v1/clients/communication/unread',
    markAllCommunicationsRead: () => 'v1/clients/communication/readAll',
    markCommunicationRead: (clientId: string, communicationId: string) => `v1/clients/${clientId}/communication/${communicationId}/read`,
    markAllClientCommunicationsRead: (clientId: string) => `v1/clients/${clientId}/communication/readAll`,
    requestClientGoogleReview: (id: string) => `v1/clients/${id}/communication/google-review`,
    clientsExportCsv: (...columns: (keyof ClientData)[]) => `v1/clients/export-csv?${columns.map(c => `columns=${c}`).join('&')}`,
    pack: (packId: string) => `v1/packs/${packId}`,
    packRequestMBwayPayment: (id: string) => `v1/packs/${id}/payments/mbw`,
    packRequestEntityRefPayment: (id: string) => `v1/packs/${id}/payments/mb`,
    packSendCheckoutEmail: (id: string) => `v1/packs/${id}/payments/send-checkout-email`,
    packInvoices: (packId: string) => `v1/packs/${packId}/invoices`,
    clientSendAppointmentsCheckoutEmail: (id: string) => `v1/clients/${id}/appointments/send-checkout-email`,
    clientAddAppointmentsPayment: (id: string) => `v1/clients/${id}/appointments/add-payment`,
    clientResetPassword: (id: string) => `v1/clients/${id}/resetPassword`,
    clientSendConsentApproval: (id: string) => `v1/clients/${id}/consent/send`,
    consentVerify: () => `v1/clients/consent/verify`,
    consentApprove: () => `v1/clients/consent/approve`,
    usersConfirmEmailPage: () => `v1/users/confirmEmail`,
    usersResetPasswordPage: () => `v1/users/resetPassword`,
    clientPackChangeLog: (packId: string) => `v1/packs/${packId}/changeLog`,
    professionals: () => 'v1/professionals',
    professionalsPublicData: () => 'v1/professionals/public-data',
    professionalMe: () => 'v1/professionals/me',
    professionalMeProfilePic: () => 'v1/professionals/me/profile-pic',
    professional: (id: string) => `v1/professionals/${id}`,
    professionalProfilePic: (id: string) => `v1/professionals/${id}/profile-pic`,
    professionalPacks: (id: string) => `v1/professionals/${id}/packs`,
    professionalPack: (id: string, packId: string) => `v1/professionals/${id}/packs/${packId}`,
    professionalAvailability: (id: string) => `v1/professionals/${id}/availability`,
    professionalAppointments: (id: string) => `v1/professionals/${id}/appointments`,
    professionalChangeLog: (id: string) => `v1/professionals/${id}/changeLog`,
    sets: (type: string) => `v1/sets/${type}`,
    setsAdd: (type: string) => `v1/sets/${type}/add`,
    appointments: () => 'v1/appointments',
    appointmentsLot: () => 'v1/appointments/lot',
    appointmentsMy: () => 'v1/appointments/my',
    appointmentsChanges: () => 'v1/appointments/changes',
    appointment: (id: string) => `v1/appointments/${id}`,
    appointmentHasHappened: (id: string) => `v1/appointments/${id}/hasHappened`,
    appointmentConfirmationStatus: (id: string) => `v1/appointments/${id}/confirmationStatus`,
    appointmentChangeLog: (id: string) => `v1/appointments/${id}/changeLog`,
    tasks: () => 'v1/tasks',
    tasksPendingSummary: () => 'v1/tasks/pending-summary',
    tasksAssignableUsers: () => 'v1/tasks/assignable-users',
    task: (id: string) => `v1/tasks/${id}`,
    taskStatus: (id: string) => `v1/tasks/${id}/status`,
    taskAssign: (id: string) => `v1/tasks/${id}/assign`,
    tasksByClient: (clientId: string) => `v1/tasks/client/${clientId}`,
    appointmentRequestMBwayPayment: (id: string) => `v1/appointments/${id}/payments/mbw`,
    appointmentRequestEntityRefPayment: (id: string) => `v1/appointments/${id}/payments/mb`,
    appointmentSendCheckoutEmail: (id: string) => `v1/appointments/${id}/payments/send-checkout-email`,
    appointmentInvoices: (id: string) => `v1/appointments/${id}/invoices`,
    appointmentsInvoices: () => 'v1/appointments/invoices',
    appointmentConfirm: (id: string) => `v1/appointments/${id}/confirm`,
    settings: () => 'v1/settings',
    generalSettings: () => 'v1/settings/general',
    generalClientsTagsSettings: () => 'v1/settings/general/clients/tags',
    extrasSettings: () => 'v1/settings/extras',
    reportsSettings: () => 'v1/settings/reports',
    reportTemplates: () => 'v1/settings/report-templates',
    reportTemplate: (templateId: string) => `v1/settings/report-templates/${templateId}`,
    reportTemplateGenerate: () => 'v1/settings/report-templates/generate',
    reportTemplateCatalog: () => 'v1/settings/report-templates/catalog',
    packsSettings: () => 'v1/settings/packs',
    packTemplates: () => 'v1/settings/pack-templates',
    packTemplate: (templateId: string) => `v1/settings/pack-templates/${templateId}`,
    remindersSettings: () => 'v1/settings/reminders',
    taskManagementSettings: () => 'v1/settings/task-management',
    alertsSettings: () => 'v1/settings/alerts',
    paymentsSettings: () => 'v1/settings/payments',
    clientsLoginSettings: () => 'v1/settings/clients-login',
    integrationsSettings: () => 'v1/settings/integrations',
    integrationsGoHighLevelUsers: () => 'v1/settings/integrations/gohighlevel/users',
    integrationsGoHighLevelSyncCalendars: () => 'v1/settings/integrations/gohighlevel/sync-calendars',
    integrationsGoHighLevelAuditLog: (pageSize: number, offset: number) => `v1/settings/integrations/gohighlevel/audit-log?pageSize=${pageSize}&offset=${offset}`,
    integrationsMailerLiteTest: () => 'v1/settings/integrations/mailerlite/test',
    integrationsMailerLiteFields: () => 'v1/settings/integrations/mailerlite/fields',
    invoicesSettings: () => 'v1/settings/invoices',
    consentManagementSettings: () => 'v1/settings/consent-management',
    waitingListSettings: () => 'v1/settings/waiting-list',
    settingsConsentManagementPdf: () => 'v1/settings/consent-management/pdf',
    clientPhysicalConsent: (id: string) => `v1/clients/${id}/consent/physical`,
    cashRegisterSettings: () => 'v1/settings/cash-register',
    cashRegisterEntries: () => 'v1/cash-register/entries',
    cashRegisterHandle: () => 'v1/cash-register/handle',
    cashRegisterReserve: () => 'v1/cash-register/reserve',
    cashRegisterWithdraw: () => 'v1/cash-register/withdraw',
    cashRegisterTransfer: () => 'v1/cash-register/transfer',
    integrationsSync: () => 'v1/settings/integrations/trigger-sync',
    integrationsClear: () => 'v1/settings/integrations/trigger-clear',
    remindersSettingsTestEmail: () => 'v1/settings/reminders/test-email',
    remindersSettingsTestSms: () => 'v1/settings/reminders/test-sms',
    remindersSettingsTestWhatsApp: () => 'v1/settings/reminders/test-whatsapp',
    googleReviewSettingsTestSms: () => 'v1/settings/google-review/test-sms',
    googleReviewSettingsTestEmail: () => 'v1/settings/google-review/test-email',
    googleReviewAnalytics: () => 'v1/google-reviews/analytics',
    notifications: () => 'v1/notifications',
    companyImageUpload: () => 'v1/settings/general/company-image',
    adminStats: () => 'v1/admin/stats',
    adminCommunicationQuotas: () => 'v1/admin/communication-quotas',
    adminCommunications: () => 'v1/admin/communications',
    adminPayments: () => 'v1/admin/payments',
    expenses: () => 'v1/expenses',
    expensesExportZip: () => 'v1/expenses/export-zip',
    expense: (id: string) => `v1/expenses/${id}`,
    expenseChangeLog: (id: string) => `v1/expenses/${id}/changeLog`,
    stock: () => 'v1/stock',
    buyStock: (id: string) => `v1/stock/${id}/buy-stock`,
    stockQuantity: (id: string) => `v1/stock/${id}/quantity`,
    stockItem: (id: string) => `v1/stock/${id}`,
    stockItemChangeLog: (id: string) => `v1/stock/${id}/changeLog`,
    stockItemHistory: (id: string) => `v1/stock/${id}/history`,
    adminChangeLog: () => 'v1/admin/changeLog',
    adminEasypayCommissions: () => 'v1/admin/easypay-commissions',
    adminDbCleanup: () => 'v1/admin/database/cleanup',
    adminPermanentlyDeleteAllData: () => 'v1/admin/database/permanently-delete-all-data',
    companyPublicData: (id: string) => `v1/companies/${id}/public-data`,
    companyAppointments: (id: string) => `v1/companies/${id}/appointments`,
    campaigns: () => 'v1/campaigns',
    campaign: (id: string) => `v1/campaigns/${id}`,
    campaignStart: (id: string) => `v1/campaigns/${id}/start`,
    campaignSend: (id: string) => `v1/campaigns/${id}/send`,
    campaignsTest: () => 'v1/campaigns/test',
    campaignTest: (id: string) => `v1/campaigns/${id}/test`,
    campaignEstimateRecipients: (id: string) => `v1/campaigns/${id}/estimate-recipients`,
    campaignsWhatsAppNotifyMe: () => 'v1/campaigns/whatsapp/notify-me',
    campaignProcesses: (id: string) => `v1/campaigns/${id}/processes`,
    campaignDuplicate: (id: string) => `v1/campaigns/${id}/duplicate`,
    campaignArchive: (id: string) => `v1/campaigns/${id}/archive`,
    campaignAnalytics: (id: string) => `v1/campaigns/${id}/analytics`,
    campaignOrders: (id: string) => `v1/campaigns/${id}/orders`,
    campaignOrder: (id: string, orderId: string) => `v1/campaigns/${id}/orders/${orderId}`,
    campaignOrderCheckout: (id: string, orderId: string) => `v1/campaigns/${id}/orders/${orderId}/checkout`,
    whatsAppTemplateCatalog: () => 'v1/whatsapp/template-catalog',
    whatsAppTemplateCatalogCampaign: () => 'v1/whatsapp/template-catalog/campaign',
    whatsAppTemplateCatalogSync: () => 'v1/whatsapp/template-catalog/sync',
    whatsAppTemplates: () => 'v1/whatsapp/templates',
    whatsAppTemplate: (id: string) => `v1/whatsapp/templates/${id}`,
    invoices: () => 'v1/invoices',
    invoicesSummary: () => 'v1/invoices/summary',
    invoicesExportPdfs: () => 'v1/invoices/export-pdfs',
    invoice: (id: string) => `v1/invoices/${id}`,
    invoiceState: (id: string) => `v1/invoices/${id}/state`,
    invoiceCreditNote: (id: string) => `v1/invoices/${id}/credit-note`,
    invoiceReceipt: (id: string) => `v1/invoices/${id}/receipt`,
    invoiceCatalog: () => 'v1/invoices/items',
    invoicesSaft: (year: string, month: string) => `v1/invoices/saft/${year}/${month}`,
    invoiceAssign: (invoiceId: string) => `v1/invoices/${invoiceId}/assign`,
    taxRates: () => 'v1/invoices/taxes',
    taxExemptions: () => 'v1/invoices/taxes/exemptions',
    monitoringError: () => 'v1/monitoring/error',
    chatDialog: () => 'v1/chat/dialog',
    subscriptions: () => 'v1/tenants/subscriptions',
    settingsSubscriptions: () => 'v1/settings/subscriptions',
    mySubscriptions: () => 'v1/tenants/my/subscriptions',
    mySubscriptionCheckout: (id: string) => `v1/tenants/my/subscriptions/${id}/checkout`,
    mySubscriptionsNext: () => 'v1/tenants/my/subscriptions/next',
    myTenantClient: () => 'v1/tenants/my/client',
    usersOnboard: () => 'v1/users/onboard',
    waitingList: () => 'v1/waiting-list',
    waitingListHistory: () => 'v1/waiting-list/history',
    waitingListByProfessional: (professionalId: string) => `v1/waiting-list/professional/${professionalId}`,
    waitingListByClient: (clientId: string) => `v1/waiting-list/client/${clientId}`,
    surveys: () => 'v1/surveys',
    surveyGenerate: () => 'v1/surveys/generate',
    survey: (id: string) => `v1/surveys/${id}`,
    surveyPreview: (id: string) => `v1/surveys/${id}/preview`,
    surveyPreviewLink: (id: string) => `v1/surveys/${id}/preview-link`,
    surveyShareLink: (id: string) => `v1/surveys/${id}/share-link`,
    surveySendToContact: (id: string) => `v1/surveys/${id}/send-to-contact`,
    surveySend: (id: string) => `v1/surveys/${id}/send`,
    surveyAnalytics: () => 'v1/surveys/analytics',
    surveyVerify: () => 'v1/surveys/verify',
    surveySubmit: () => 'v1/surveys/submit',
    prescriptions: () => 'v1/prescriptions',
    prescriptionsByClient: (clientId: string) => `v1/prescriptions/client/${clientId}`,
    prescription: (id: string) => `v1/prescriptions/${id}`,
    prescriptionsSettings: () => 'v1/settings/prescriptions',
    medicineSearch: (q: string) => `v1/prescriptions/medicine-search?q=${encodeURIComponent(q)}`,
    googleCalendarStatus: () => 'v1/google-calendar/status',
    googleCalendarAuthUrl: () => 'v1/google-calendar/auth-url',
    googleCalendarConnect: () => 'v1/google-calendar/connect',
    googleCalendarDisconnect: () => 'v1/google-calendar/disconnect',
    aiScriberSession: (appointmentId: string) => `v1/appointments/${appointmentId}/ai-scriber/session`,
    aiScriberSessionAudioChunk: (appointmentId: string, sessionId: string) => `v1/appointments/${appointmentId}/ai-scriber/session/${sessionId}/chunk`,
    aiScriberSessionStop: (appointmentId: string, sessionId: string) => `v1/appointments/${appointmentId}/ai-scriber/session/${sessionId}/stop`,
    systemTenantsPayments: () => 'v1/system/tenants/payments',
    systemTenantsPaymentsMinComissions: () => 'v1/system/tenants/payments/min-comissions',
};

export const buildAjaxUrl = (route: string = '') => {
    return window.location.pathname + route;
}
